import { MedicalReportDTO, MedicalReport } from '../../interfaces/medicalReport';
import { workspace } from '../../shared/api';

export const MedicalReportService = {
  async delete(prescriptionId: number, prescriptionMedicalReportId: number): Promise<void> {
    await workspace.delete(`/prescricao/${prescriptionId}/laudo-medico/${prescriptionMedicalReportId}`);
  },
  async update(prescriptionId: number, medicalReport: MedicalReportDTO): Promise<MedicalReport> {
    const payload: Partial<MedicalReport> = {
      DataLaudoMedico: medicalReport.medicalReportDate,
      Texto: medicalReport.text,
      Titulo: medicalReport.title,
    };

    const { data } = await workspace.put(
      `/prescricao/${prescriptionId}/laudo-medico/${medicalReport.medicalReportId}`,
      payload
    );

    return data.data;
  },
  async create(prescriptionId: number, medicalReport: MedicalReportDTO): Promise<MedicalReport> {
    const payload: Partial<MedicalReport> = {
      DataLaudoMedico: medicalReport.medicalReportDate,
      Texto: medicalReport.text,
      Titulo: medicalReport.title,
    };

    const { data } = await workspace.post(`/prescricao/${prescriptionId}/laudo-medico`, payload);

    return data.data;
  },
};
